export const initOtpInput = () => {
    const otpInputs = document.querySelectorAll('.otp-input-container input[type="text"]');
    const otpValue = document.getElementById('otp-value');

    if (!otpInputs.length || !otpValue) return;

    // Function to handle input value change
    const handleInput = (e) => {
        // Only allow numbers
        e.target.value = e.target.value.replace(/[^0-9]/g, '');

        // Auto focus next input if current input has value
        const index = Array.from(otpInputs).indexOf(e.target);
        if (e.target.value && index < otpInputs.length - 1) {
            otpInputs[index + 1].focus();
        }

        // Update hidden input
        updateOtpValue();
    };

    // Handle input and keyup
    otpInputs.forEach((input, index) => {
        // Listen for both input and keyup events
        input.addEventListener('input', handleInput);
        input.addEventListener('keyup', (e) => {
            // Handle number keys
            if (/^[0-9]$/.test(e.key)) {
                handleInput(e);
            }
        });

        // Handle backspace
        input.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace') {
                if (!e.target.value && index > 0) {
                    // If current input is empty and backspace is pressed, focus previous input
                    otpInputs[index - 1].focus();
                }
            }
        });

        // Handle paste
        input.addEventListener('paste', (e) => {
            e.preventDefault();
            const pastedData = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, 6);

            if (pastedData) {
                pastedData.split('').forEach((digit, i) => {
                    if (otpInputs[i]) {
                        otpInputs[i].value = digit;
                    }
                });

                // Focus last filled input or next empty input
                const lastFilledIndex = Math.min(pastedData.length, otpInputs.length - 1);
                otpInputs[lastFilledIndex].focus();

                updateOtpValue();
            }
        });
    });

    // Update hidden input value
    function updateOtpValue() {
        const value = Array.from(otpInputs).map(input => input.value).join('');
        otpValue.value = value;
    }

    // Form validation
    const form = otpInputs[0].closest('form');
    if (form) {
        form.addEventListener('submit', (e) => {
            const otp = otpValue.value;
            if (otp.length !== 6) {
                e.preventDefault();
                alert('Vui lòng nhập đủ 6 số OTP');
            }
        });
    }
}; 